// extracted by mini-css-extract-plugin
module.exports = {"Columns":"Masonry__Columns_FBkoh grid","Column":"Masonry__Column_2Tvom grid"};